import { IconBaseProps } from "react-icons";
import { GoPencil } from "react-icons/go";

const EditIcon = ({ ...rest }: IconBaseProps) => {
  return <GoPencil {...rest} />;
};

export default EditIcon;
